import { BlogPage } from "./Blog";
export default BlogPage;
